import React, { useEffect } from "react";
import "./styles.css";
import NewHeaderStatic from "../Component/NewHeader/NewHeaderStatic";
import FooterStatic from "../Component/FooterStatic";
import {Helmet} from "react-helmet";

const AboutUs = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="StaticMainComponent">
      <div className="MainStaticMainComponentContaint">
      <Helmet>
      <title>Booking Term and Condition : Holidays Seychelles</title>
      <meta name="keywords" content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"/>
    </Helmet>
    <h1 style={{color:'#fff'}}> Booking Term and Condition : Holidays Seychelles</h1>
        <NewHeaderStatic page={"inner_listing"} />
        <div
          className="StaticlandingCard appendBottom20 StaticSection page-section"
          style={{ marginTop: 150 }}
        >
          <div className="StaticContainer" id="container">
            <div class="row">
              <div className="aboutPage">
                <h1 className="termHeading">Terms of Use</h1>
                <p className="textnew">Last updated; 15th Jan 2023 </p>
                <h3 style={{paddingBottom:'10px', paddingTop:'10px'}}>Welcome to Holidays Seychelles!</h3> 
                {/* <h3>Disclaimer</h3> */}
                <p className="text">
                These Terms of Use apply to any use of Holidays Seychelles services. Please read these Terms of Use carefully, as they contain important information concerning the use of the features and services provided by the holidays Seychelles. <br></br>
                The domain name <a href="www.holidays-seychelles.com"></a>www.holidays-seychelles.com, including the related website and application as well as the Agent Portal (agents.holidays-seychelles.com) (hereinafter referred to as “Platform”) is owned and operated by ESPACE Seychelles Ltd. (hereinafter referred to as 'Holidays Seychelles'), a company with its registered office at Au CAP, Mahe Seychelles, P.O Box 2021, Anse Aux Pins, Mahe, Seychelles.
                <br></br>
                For the purpose of the Terms of Use (hereinafter referred to as “ToU”), wherever the context so requires, ‘you’ and ‘your’ shall relate to any natural or legal person who has agreed to become an Agent on the Platform by providing registration data while registering on the Platform using computer systems. The word ‘user’ shall collectively imply an Agent, Supplier, and any visitor on the Platform and the terms ‘we’, ‘us’ and ‘our’ shall mean Holidays Seychelles.
                </p>
                <h3>Disclaimer</h3>
                <p className="text">
                We have done our upmost to provide accurate information. However, within the technological sphere there are always space for bugs, errors, problems, or other limitations to manifest itself without warning. The owner of this site assumes no liability or responsibility for any errors or omissions on this site, or for any loss or damage arising directly or indirectly from the possession, publication, or use of or reliance on information obtained from this website. It is provided in good faith, but without express or implied warranty.
                </p>
                <h3>Accuracy of information</h3>
                <p className="text">
                Holidays Seychelles attempts to ensure that the information contained in its web site and those of its partners is accurate and up to date, but people intending to act on any information contained on these sites should first check with Holidays Seychelles or the local e-marketplace owner/operator to ascertain whether any later information is available.
                </p>
                <h3>Obligations</h3>
                <p className="text">
                All bookings made from this website will be respected by contract between Holidays Seychelles and the Supplier. However, in normal operation it is not a perfect world and issues may arise. When such issue arises, the supplier will meet their obligations with an equivalent product. However, it must be clear that the agent owns the reservation and the client. In case of dispute between the agent and the client. Holidays Seychelles cannot intervene.
                </p>
                <h3>External links</h3>
                <p className="text">
                A project of this size relies on many third-party API that provide connectivity between systems. Holidays Seychelles and partner web sites, in addition to links to other partner sites, may contain links to other websites not associated with Holidays Seychelles. Such links are not endorsements of any information, products or services in such sites, and no information in external sites has been endorsed or approved by us. If you have any questions in relation to the above please contact us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterStatic showNews={"noNews"} />
    </div>
  );
};

export default AboutUs;
